/* SOSband: la primera vez que alguien entra, lo lleva al mercado de su país (ES, FR, IT, US) con su idioma. */
(function () {
  try {
    var KEY = 'ps_geo_v1';
    if (window.Shopify && Shopify.designMode) return;
    if (/bot|crawl|spider|slurp|lighthouse|preview/i.test(navigator.userAgent)) return;
    if (localStorage.getItem(KEY)) return;
    var form = document.getElementById('ps-geo-form');
    if (!form) return;
    var IDIOMA = { ES: 'es', FR: 'fr', IT: 'it', US: 'en' };
    var actual = form.querySelector('[name=country_code]').value;
    fetch('/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=XX&language[enabled]=false', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var pais = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        localStorage.setItem(KEY, '1');
        if (!pais || !IDIOMA[pais] || pais === actual) return;
        form.querySelector('[name=country_code]').value = pais;
        form.querySelector('[name=language_code]').value = IDIOMA[pais];
        form.submit();
      })
      .catch(function () {});
  } catch (e) {}
})();
